/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Degraded_Retry_In_ProgressInputs */

const en_rmf_degraded_retry_in_progress = /** @type {(inputs: Rmf_Degraded_Retry_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry in progress…`)
};

const fr_rmf_degraded_retry_in_progress = /** @type {(inputs: Rmf_Degraded_Retry_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relance en cours…`)
};

const ms_sg2_rmf_degraded_retry_in_progress = /** @type {(inputs: Rmf_Degraded_Retry_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubaan semula sedang dijalankan…`)
};

/**
* | output |
* | --- |
* | "Retry in progress…" |
*
* @param {Rmf_Degraded_Retry_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_degraded_retry_in_progress = /** @type {((inputs?: Rmf_Degraded_Retry_In_ProgressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Degraded_Retry_In_ProgressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_degraded_retry_in_progress(inputs)
	if (locale === "fr") return fr_rmf_degraded_retry_in_progress(inputs)
	return ms_sg2_rmf_degraded_retry_in_progress(inputs)
});